import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../config.service';
import { AESService } from '../encryption/aes.service';
// const httpOptions = {
//   headers: new HttpHeaders({ 'Access-Control-Allow-Origin':'*','Content-Type': 'application/json', })
// };

@Injectable()

export class ListBlogService {

  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
   
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  ListBlogs(): Observable<any> {
    return this.http.get(this.config.baseURL + '/blog/listblog', this.httpOptions)
      .map((res) => { return res }

      );
  }
  
  videoCetgory(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/blog/createVideoCategory', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  ListCategory(): Observable<any> {
    return this.http.post(this.config.baseURL + '/blog/listVideoCategory', this.httpOptions)
      .map((res) => { return res }

      );
  }
  publish(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/blog/ispublish', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  updateBlog(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/blog/updateblog', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  updateCat(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/blog/updatevideocategory', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  deleteCat(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/blog/deleteVideoCategory', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
  deleteBlog(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/blog/deleteblog', user, this.httpOptions)
      .map((res) => { return res }

      );
  }

}
